import React from 'react';
import ReactQuill, {Quill} from 'react-quill';

const Block = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);

// function removeLastBr(text) {
//     if (text.substring(text.length - 15, text.length) == '<div><br></div>') {
//         return text.substring(0, text.length - 15);
//     }
//     return text;
// }

const modules =
    {
        toolbar: [
            [{header: [1, 2, false]}],
            ['bold', 'italic', 'underline'],
            [{color: []}, {background: []}],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{'indent': '-1'}, {'indent': '+1'}]
        ],
    };
const RichTextArea = function RichTextArea({onChange, ...rest}) {

    return <ReactQuill theme='bubble' modules={modules} {...rest}  onChange={(text, delta, source) => source === 'user' && onChange(text)} />
};


export default React.memo(RichTextArea);